import gql from 'graphql-tag'
import {fragmentPostDetail} from './post'
import {fragmentUserList} from './user'
import {fragmentBackpack} from './backpack'

export const fragmentAdventureDetail = gql`
	fragment AdventureDetail on Adventure {
		id
		title
		description
		privacy
		viewerCanRead
		viewerCanUpdate
		viewerCanPost
		viewerIsParticipant
		viewerParticipation {
			id
		}
		author {
			id
			fullname
		}
		map {
			bounds {
				southWest {
					lat
					lng
				}
				northEast {
					lat
					lng
				}
				center {
					lat
					lng
				}
			}
			points {
				lat
				lng
			}
		}
	}
`

export const fragmentAdventurePosts = gql`
	fragment AdventurePosts on Adventure {
		id
		posts {
			reset @client
		}
	}
`

export const fragmentNewParticipation = gql`
	fragment NewParticipation on Participation {
		id
		receiver {
			...UserList
		}
	}
	${fragmentUserList}
`


export const queryAdventure = gql`
	query adventure($id: ID!) {
		adventure(id: $id) {
			...AdventureDetail
		}
	}
	${fragmentAdventureDetail}
`

export const queryAdventureFeed = gql`
	query adventureFeed($id: ID!, $offset: Int!, $limit: Int!) {
		adventure(id: $id) {
			id
			posts(limit: $limit, offset: $offset) {
				pagination {
					offset
					limit
					total
				}
				edges {
					...PostDetail
				}
			}
		}
	}
	${fragmentPostDetail}
`

export const queryAdventureFeedNew = gql`
	query adventureFeed($id: ID!) {
		adventure(id: $id) {
			posts(limit: 0, offset: 0) {
				pagination {
					total
				}
			}
		}
	}
`

export const queryAdventureParticipations = gql`
	query adventureParticipations($id: ID!) {
		adventure(id: $id) {
			id
			participations {
				pagination {
					offset
					limit
					total
				}
				edges {
					id
					receiver {
						...UserList
					}
					backpack {
						...BackpackDetail
					}
				}
			}
		}
	}
	${fragmentUserList}
	${fragmentBackpack}
`

export const mutationCreateAdventure = gql`
	mutation createAdventure($input: CreateAdventureInput!) {
		createAdventure(input: $input) {
			adventure {
				...AdventureDetail
			}
		}
	}
	${fragmentAdventureDetail}
`

export const mutationUpdateAdventure = gql`
	mutation updateAdventure($input: UpdateAdventureInput!) {
		updateAdventure(input: $input) {
			adventure {
				...AdventureDetail
			}
		}
	}
	${fragmentAdventureDetail}
`

export const mutationDeleteAdventure = gql`
	mutation deleteAdventure($input: DeleteAdventureInput!) {
		deleteAdventure(input: $input) {
			success
			id
		}
	}
`

export const mutationRemoveParticipator = gql`
	mutation removeParticipator($input: DeleteParticipationInput!) {
		removeParticipator(input: $input) {
			success
			participation {
				id
			}
		}
	}
`

export const mutationInviteParticipator = gql`
	mutation inviteParticipator($input: CreateParticipationInput!) {
		inviteParticipator(input: $input) {
			participation {
				id
				receiver {
					...UserList
				}
			}
		}
	}
	${fragmentUserList}
`
